import { ExamQuestion } from '../types';

// Helper to generate mock questions
const generateQuestions = (
    startId: number,
    count: number,
    examType: 'TYT' | 'AYT' | 'YDT',
    section: string,
    topicPrefix: string
): ExamQuestion[] => {
    return Array.from({ length: count }).map((_, i) => ({
        id: startId + i,
        examType,
        section,
        questionNumber: i + 1,
        text: `${section} bölümü ${i + 1}. soru: Aşağıdakilerden hangisi ${topicPrefix} ile ilgilidir? \n(Bu bir örnek sorudur. Gerçek sınavda burada ilgili dersin sorusu yer alacaktır.)`,
        options: [
            { label: 'A', text: 'Seçenek A' },
            { label: 'B', text: 'Seçenek B' },
            { label: 'C', text: 'Seçenek C' },
            { label: 'D', text: 'Seçenek D' },
            { label: 'E', text: 'Seçenek E' },
        ],
        correctOption: ['A', 'B', 'C', 'D', 'E'][Math.floor(Math.random() * 5)],
        topic: `${topicPrefix} Konu ${Math.ceil((i + 1) / 5)}`, // Every 5 questions link to a topic
    }));
};

// --- TYT Exams ---
const MOCK_TYT_1: ExamQuestion[] = [
    {
        id: 1,
        examType: 'TYT',
        section: 'Temel Matematik',
        questionNumber: 1,
        text: "Bir markette a liraya satılan bir ürüne %20 zam yapıldığında ürünün yeni fiyatı a + 4 lira oluyor. Buna göre, a kaçtır?",
        options: [
            { label: 'A', text: '15' },
            { label: 'B', text: '20' },
            { label: 'C', text: '24' },
            { label: 'D', text: '30' },
            { label: 'E', text: '36' },
        ],
        correctOption: 'B',
        topic: 'Yüzde Problemleri',
        solution: "Ürüne %20 zam yapıldığında fiyatı 0.20a artar.\nBu artış 4 liraya eşittir.\n0.20a = 4\na/5 = 4\na = 20 bulunur."
    },
    {
        id: 2,
        examType: 'TYT',
        section: 'Türkçe',
        questionNumber: 1,
        text: "Yukarıdaki parçada numaralanmış cümlelerin hangisinde 'hayal kırıklığı' anlamı vardır?",
        options: [
            { label: 'A', text: 'I' },
            { label: 'B', text: 'II' },
            { label: 'C', text: 'III' },
            { label: 'D', text: 'IV' },
            { label: 'E', text: 'V' },
        ],
        correctOption: 'C',
        topic: 'Cümlede Anlam',
        solution: "III. cümlede 'beklediğimiz sonucu alamayınca hepimiz üzüldük' ifadesi, gerçekleşmeyen bir beklentiden doğan üzüntüyü, yani hayal kırıklığını ifade eder."
    },
    ...generateQuestions(1002, 38, 'TYT', 'Türkçe', 'Dil Bilgisi'), // Adjusted startId and count
    ...generateQuestions(1040, 20, 'TYT', 'Sosyal Bilimler', 'Tarih/Coğrafya'),
    ...generateQuestions(1060, 40, 'TYT', 'Matematik', 'Temel Matematik'),
    ...generateQuestions(1100, 20, 'TYT', 'Fen Bilimleri', 'Fizik/Kimya/Biyoloji'),
];

const MOCK_TYT_2: ExamQuestion[] = [
    ...generateQuestions(2000, 40, 'TYT', 'Türkçe', 'Paragraf'),
    ...generateQuestions(2040, 20, 'TYT', 'Sosyal Bilimler', 'Felsefe/Din'),
    ...generateQuestions(2060, 40, 'TYT', 'Matematik', 'Problemler'),
    ...generateQuestions(2100, 20, 'TYT', 'Fen Bilimleri', 'Fizik/Kimya'),
];

// --- AYT Exams ---
const MOCK_AYT_SAY: ExamQuestion[] = [
    ...generateQuestions(3000, 40, 'AYT', 'Matematik', 'İleri Matematik'),
    ...generateQuestions(3040, 40, 'AYT', 'Fen Bilimleri', 'Fizik/Kimya/Biyoloji'),
];

const MOCK_AYT_EA: ExamQuestion[] = [
    ...generateQuestions(4000, 40, 'AYT', 'Matematik', 'İleri Matematik'),
    ...generateQuestions(4040, 40, 'AYT', 'Türk Dili ve Edebiyatı-Sosyal Bilimler-1', 'Edebiyat/Tarih'),
];

const MOCK_AYT_SOZ: ExamQuestion[] = [
    ...generateQuestions(5000, 40, 'AYT', 'Türk Dili ve Edebiyatı-Sosyal Bilimler-1', 'Edebiyat/Tarih'),
    ...generateQuestions(5040, 40, 'AYT', 'Sosyal Bilimler-2', 'Tarih-2/Coğrafya-2/Felsefe'),
];

// --- YDT Exams ---
const MOCK_YDT_1: ExamQuestion[] = [
    ...generateQuestions(6000, 80, 'YDT', 'Yabancı Dil', 'İngilizce'),
];

// Exam Metadata
export const MOCK_EXAMS = [
    { id: 'tyt-1', name: 'TYT Deneme Sınavı 1', type: 'TYT', duration: 165, questions: MOCK_TYT_1 },
    { id: 'tyt-2', name: 'TYT Deneme Sınavı 2', type: 'TYT', duration: 165, questions: MOCK_TYT_2 },
    { id: 'ayt-say-1', name: 'AYT Sayısal Deneme 1', type: 'AYT', duration: 180, questions: MOCK_AYT_SAY },
    { id: 'ayt-ea-1', name: 'AYT Eşit Ağırlık Deneme 1', type: 'AYT', duration: 180, questions: MOCK_AYT_EA },
    { id: 'ayt-soz-1', name: 'AYT Sözel Deneme 1', type: 'AYT', duration: 180, questions: MOCK_AYT_SOZ },
    { id: 'ydt-1', name: 'YDT İngilizce Deneme 1', type: 'YDT', duration: 120, questions: MOCK_YDT_1 },
];
